import React from 'react'
import isString from 'lodash/isString'
import PropTypes from 'prop-types'

import clsx from 'clsx'
import { makeStyles } from '@mui/styles'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import IconClose from '@assets/images/icons/v2/close.svg'
import IconCollapse from '@assets/images/icons/collapse_icon_new.svg'
import PanelHeader from '@/components/layouts/panel/panel-header'

const defaultPadding = 30

const useStyles = makeStyles(theme => ({
  header: {
    alignItems: 'center',
    height: 80,
    justifyContent: 'space-between',
    fontSize: theme.fontSizes.large,
    color: theme.black,
    display: 'flex',
    width: '100%',
    backgroundColor: theme.backgroundColor,
    '& > *': {
      padding: defaultPadding,
    },
    '& a': {
      border: theme.border,
      backgroundColor: theme.white,
      minWidth: 45,
      minHeight: 45,
    },
    '& a:hover': {
      backgroundColor: theme.backgroundColor,
    },
  },
  close: {
    cursor: 'pointer',
  },
}))

const BaseDrawerPanelHeader = (props) => {
  const classes = useStyles(props)
  const {
    onClose,
    className,
    children,
    showCloseIcon = true,
    showCollapseIcon,
  } = props

  return (
    <PanelHeader toolbarRender={() => (
      <div className={clsx(classes.header, className)}>
        {isString(children) ? (<div>{children}</div>) : children}
        {showCloseIcon
          ? (
            <div>
              <SVGIcon className={classes.close} onClick={onClose} svg={showCollapseIcon ? IconCollapse : IconClose} width={'12px'} height={'12px'} />
            </div>
          )
          : null}
      </div>
    )} />
  )
}

BaseDrawerPanelHeader.propTypes = {
  onClose: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node,
  showCloseIcon: PropTypes.bool,
  showCollapseIcon: PropTypes.bool,
}

export default BaseDrawerPanelHeader
